import { FC } from "react";
import { useForm } from "react-final-form";

import { Link, MessageBar, Stack, Text } from "@bps/fluent-ui";
import { Contact } from "@stores/practice/models/Contact.ts";

import { ContactMethodListAddresses } from "../../view/contact-method-list/ContactMethodListAddresses.tsx";
import { ContactMethodListCommunications } from "../../view/contact-method-list/ContactMethodListCommunications.tsx";
import {
  PatientEditFormValues,
  patientFormNameOf
} from "../PatientEditFormValues.tsx";

interface LinkedEmployerContactMethodsProps {
  contact: Contact;
  index: number | undefined;
  messageHeader: string;
}

export const LinkedEmployerContactMethods: FC<
  LinkedEmployerContactMethodsProps
> = ({ contact, index, messageHeader }) => {
  const { mutators } = useForm<PatientEditFormValues>();

  return (
    <Stack
      tokens={{ childrenGap: 8 }}
      styles={(_props, theme) => ({
        root: {
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: theme.palette.neutralLight,
          borderRadius: "2px",
          padding: 8,
          marginBottom: 16
        }
      })}
    >
      {contact.addresses.length > 0 || contact.communications.length > 0 ? (
        <>
          <MessageBar styles={{ innerText: { width: "100%" } }}>
            <Stack horizontal horizontalAlign="space-between">
              {messageHeader}
              <Link
                onClick={() =>
                  mutators.remove(
                    patientFormNameOf("linkedOrganisationContactIds"),
                    index
                  )
                }
              >
                Remove
              </Link>
            </Stack>
          </MessageBar>
          <ContactMethodListCommunications
            isOrganisation={true}
            contact={contact}
          />
          <ContactMethodListAddresses contact={contact} />
        </>
      ) : (
        <MessageBar>
          <Stack
            horizontal
            horizontalAlign="space-between"
            tokens={{ childrenGap: 16 }}
          >
            <Text
              styles={{
                root: { color: "inherit", fontSize: "inherit" }
              }}
            >
              No contact methods for {contact.name}, but they will propagate
              here if added to {contact.name}
            </Text>
            <Link
              styles={{ root: { width: 56, display: "inline-flex" } }}
              onClick={() =>
                mutators.remove(
                  patientFormNameOf("linkedOrganisationContactIds"),
                  index
                )
              }
            >
              Remove
            </Link>
          </Stack>
        </MessageBar>
      )}
    </Stack>
  );
};
